import { CreateTagInterface, TagInterface, TagRepositoryInterface } from '@/services/QC-V2/tag/interfaces';
import { AxiosInstance } from 'axios';

export default class TagRepository implements TagRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getActiveTags(): Promise<TagInterface[]> {
    const response = await this.axios.get('/qa-controller-v2/tags');

    return response.data;
  }

  public async getAllTags(): Promise<TagInterface[]> {
    const response = await this.axios.get('/qa-controller-v2/tags/all');

    return response.data;
  }

  public async getOneById(id: number): Promise<TagInterface> {
    const response = await this.axios.get(`/qa-controller-v2/tags/${id}`);

    return response.data;
  }

  public async addChatTags(id: string, tags: number[]): Promise<void> {
    await this.axios.post(`/chat-controller-v2/chats/${id}/tags`, tags);
  }

  public async createTag(data: CreateTagInterface): Promise<TagInterface> {
    const response = await this.axios.post('/qa-controller-v2/tags', data);

    return response.data;
  }

  public async editTag(tagId: number, tagData: Partial<TagInterface>): Promise<void> {
    await this.axios.patch(`/qa-controller-v2/tags/${tagId}`, tagData);
  }

  public async deleteTag(tagId: number): Promise<void> {
    await this.axios.delete(`/qa-controller-v2/tags/${tagId}`);
  }

  public async addTicketTags(id: number, tags: number[]): Promise<void> {
    await this.axios.post(`/ticket-controller-v2/tickets/${id}/tags`, tags);
  }
}
